import { MT5Account } from 'types/MT5Account';

export const getAccounts = async (functionKey: string | null): Promise<MT5Account[]> => {
    if (!functionKey) throw new Error('Function key is required');
    const url = `https://trade-machine.azurewebsites.net/api/GetAccountsData?code=${functionKey}`;
    return fetch(url).then((res) => res.json());
};
